import { type Distributor, distributorSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { queryKeys } from './queryKeys';

const responseSchema = z.object({
  distributors: z.array(distributorSchema),
});

export function useDistributors() {
  const url = `/distributors`;

  const { data, error, isLoading } = useQuery<{
    distributors: Distributor[];
  }>({
    queryKey: queryKeys.getDistributors,
    queryFn: () => get({ url, schema: responseSchema }),
  });

  return {
    distributors: data?.distributors || [],
    error,
    isLoading,
  };
}
